import { checkTenant } from "api/user";
import { ApiResponse } from "constantVariables";
import { languageMap } from "constantVariables/language";
import { useTenant } from "context/tenantProvider";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLanguage, setTenant } from "store/slices";
import { decrypt } from "utils/crypto";
import i18n from "utils/i18n";

export function useCheckTenant() {
  const [isLoading, setIsLoading] = useState(true);
  const [tenantNotFound, setTenantNotFound] = useState(false);
  const [hubspot, setHubspot] = useState();
  const dispatch = useDispatch();

  const { tenant, isLoading: tenantLoading } = useTenant();

  useEffect(() => {
    if (!tenant) {
      return;
    }
    if (tenant === "-1") {
      setIsLoading(false);
      return;
    }
    checkTenant()
      .then((data) => {
        setIsLoading(false);
        if (data.statusCode !== ApiResponse.SUCCESS) {
          setTenantNotFound(true);
          const { lang, dir, title, hubspotId } = languageMap["english"];

          i18n.changeLanguage(lang);
          dispatch(setLanguage({ lang, dir, title }));
          setHubspot(hubspotId);
        } else {
          const decData = decrypt(data.data);
          const { lang, dir, title, hubspotId } =
            languageMap[decData.prefer_language[0] || "english"];
          i18n.changeLanguage(lang);
          dispatch(setLanguage({ lang, dir, title }));
          dispatch(setTenant(decData ?? null));
          setHubspot(hubspotId);
        }
      })
      .catch((err) => {
        const { lang, dir, title, hubspotId } = languageMap["english"];

        i18n.changeLanguage(lang);
        dispatch(setLanguage({ lang, dir, title }));
        setHubspot(hubspotId);
        setTenantNotFound(true);
        setIsLoading(false);
      });
  }, [tenant]);

  return { isLoading: isLoading || tenantLoading, tenantNotFound, hubspot };
}
